<section class="row-freight d-flex px-0 px-sm-2" [ngClass]="{'inactive-address': !isActiveThirdPartyAddress}">
    <div class="col-12 px-0 address-item">

        <div class="address-item__content row mx-0">
            <div class="col-12">
                <span class="badge badge-pill badge-success badge-company-state" *ngIf="!isActiveThirdPartyAddress"
                    [ngClass]="{'badge-danger': !isActiveThirdPartyAddress}">
                    <span *ngIf="isActiveThirdPartyAddress">Dirección activa</span>
                    <span *ngIf="!isActiveThirdPartyAddress">
                        Dirección inactiva{{thirdPartyAddress?.state?.description? ': ' +
                        thirdPartyAddress?.state?.description : ''}}
                    </span>
                </span>
                <div class="label">
                    Nombre de sede
                    <i class="far fa-copy icon-copy"
                        *ngIf="thirdPartyAddress?.branchOfficeName || thirdPartyAddress?.address?.address"
                        (click)="utils.copyMessage(thirdPartyAddress?.branchOfficeName? thirdPartyAddress?.branchOfficeName : thirdPartyAddress?.address?.address)"></i>
                </div>
                <div class="text-bold label-field"
                    title="{{thirdPartyAddress?.branchOfficeName? thirdPartyAddress?.branchOfficeName : thirdPartyAddress?.address?.address}}">
                    {{thirdPartyAddress?.branchOfficeName? thirdPartyAddress?.branchOfficeName :
                    thirdPartyAddress?.address?.address ? thirdPartyAddress?.address?.address : '-'}}
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="label">
                    Ciudad
                </div>
                <div class="text-bold label-field" title="{{city}}">
                    {{city ? city : '-'}}
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="label">
                    Dirección
                </div>
                <div class="text-bold label-field" title="{{thirdPartyAddress?.address?.address}}">
                    {{thirdPartyAddress?.address?.address ? thirdPartyAddress?.address?.address : '-'}}
                </div>
            </div>
            <div class="col-md-6 col-lg-2">
                <div class="label">
                    Código
                </div>
                <div class="text-bold label-field" title="{{thirdPartyAddress?.address?.id}}">
                    {{showIDError.show ? '-' : thirdPartyAddress?.address?.id}}
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="label">
                    Latitud
                    <i class="far fa-copy icon-copy" *ngIf="thirdPartyAddress?.address?.location?.lat"
                        (click)="utils.copyMessage(thirdPartyAddress?.address?.location?.lat)"></i>
                </div>
                <div class="text-bold label-field" title="{{thirdPartyAddress?.address?.location?.lat}}">
                    {{thirdPartyAddress?.address?.location?.lat ? thirdPartyAddress?.address?.location?.lat : '-'}}
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="label">
                    Longitud
                    <i class="far fa-copy icon-copy" *ngIf="thirdPartyAddress?.address?.location?.lng"
                        (click)="utils.copyMessage(thirdPartyAddress?.address?.location?.lng)"></i>
                </div>
                <div class="text-bold label-field" title="{{thirdPartyAddress?.address?.location?.lng}}">
                    {{thirdPartyAddress?.address?.location?.lng ? thirdPartyAddress?.address?.location?.lng : '-'}}
                </div>
            </div>
            <div class="actions">
                <i *ngIf="hasPermissionToEnableDisableThirdParty && thirdPartyAddress?.addressId"
                    [class.fa-toggle-on]="isActiveThirdPartyAddress" class="fas"
                    [class.fa-toggle-off]="!isActiveThirdPartyAddress"
                    [matTooltip]="isActiveThirdPartyAddress ? 'Desactivar dirección de tercero' : 'Activar dirección de tercero'"
                    (click)="setThirdPartyAddressState(!isActiveThirdPartyAddress)">
                </i>

                <i class="fas fa-eye" (click)="checkLocation()" *ngIf="!showLocationError && !showIDError.show"
                    matTooltip="Ver ubicación">
                </i>
                <i permission-display [module]="permission.administration.module"
                    [functionality]="permission.administration.editThirdPartyAddress"
                    class="fas fa-edit icon-edit-location" (click)="editThirdPartyAddressDialog()"
                    *ngIf="!showLocationError && !showIDError.show" matTooltip="Editar dirección">
                </i>
            </div>
        </div>

        <app-rndc-contingency-alert class="col-12 mt-3 px-0" [entity]="thirdPartyAddress"
            entityType="thirdPartyAddress"></app-rndc-contingency-alert>
        <div class="col-12 mt-3 px-0 alert alert-warning d-flex align-items-center justify-content-center text-bold"
            role="alert" *ngIf="showLocationError">
            <i class="fas fa-exclamation-triangle"></i>
            <span> Esta dirección no tiene una ubicación geográfica asignada.</span>
            <u class="ml-2 cursor-pointer" (click)="openAddLatLng()" *ngIf="canAddLatLng"> ¿Desea asociarla?</u>
        </div>
        <div class="col-12 mt-3 px-0 alert alert-danger d-flex align-items-center justify-content-center text-bold"
            role="alert" *ngIf="showIDError.show">
            <i class="fas fa-exclamation-triangle"></i>
            <span> {{showIDError.reason}}</span>
        </div>
    </div>
</section>